import { events } from "@planzone/events";
import { Boundaries } from "@planzone/core";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleEditPlanzoneSettingsRequest(
  state: State,
  { planzone }: Boundaries["editPlanzoneSettings"]["request"],
): State {
  const index = state.findIndex((req) => req.planzone.uuid === planzone.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { ...state[index], request: setRequestStateToPending() },
        ...state.slice(index + 1),
      ]
    : [...state, { planzone, request: setRequestStateToPending() }];
}

function handleEditPlanzoneSettingsSuccess(
  state: State,
  { planzone }: Boundaries["editPlanzoneSettings"]["success"],
): State {
  const index = state.findIndex((req) => req.planzone.uuid === planzone.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { ...state[index], request: setRequestStateToSuccess() },
        ...state.slice(index + 1),
      ]
    : [...state, { planzone, request: setRequestStateToSuccess() }];
}

function handleEditPlanzoneSettingsFailure(
  state: State,
  { planzone }: Boundaries["editPlanzoneSettings"]["failure"],
): State {
  const index = state.findIndex((req) => req.planzone.uuid === planzone.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { ...state[index], request: setRequestStateToFailure() },
        ...state.slice(index + 1),
      ]
    : [...state, { planzone, request: setRequestStateToFailure() }];
}

const reduceState = createStateReducer(initialState, {
  [events.editPlanzoneSettingsRequested]: handleEditPlanzoneSettingsRequest,
  [events.editPlanzoneSettingsSucceeded]: handleEditPlanzoneSettingsSuccess,
  [events.editPlanzoneSettingsFailed]: handleEditPlanzoneSettingsFailure,
});

export type { State, Selector };

export { reduceState, initialState, createSelector };
